import TransmedCoordinator, {
  TransmedCoordinatorInput,
  TransmedCoordinatorUpdateInput,
} from "../../../dtos/transmed/process/coordinator";
import Service, {
  ServiceCreator,
  ServiceDeleter,
  ServiceReader,
  ServiceUpdater,
} from "../..";
import TransmedCoordinatorApi from "../../../api/transmed/coordinator";

class TransmedCoordinatorServiceReader extends ServiceReader {
  public async current(): Promise<TransmedCoordinator[]> {
    return await new TransmedCoordinatorApi().get();
  }
}

class TransmedCoordinatorServiceCreator extends ServiceCreator {
  public async coordinator(public_id: string): Promise<TransmedCoordinator> {
    return await new TransmedCoordinatorApi().post(
      new TransmedCoordinatorInput(public_id)
    );
  }
}

class TransmedCoordinatorServiceUpdater extends ServiceUpdater {
  public async isAssistant(
    id: number,
    isAssistant: boolean
  ): Promise<TransmedCoordinator> {
    return await new TransmedCoordinatorApi().put(
      `${id}`,
      new TransmedCoordinatorUpdateInput(isAssistant)
    );
  }
}

class TransmedCoordinatorServiceDeleter extends ServiceDeleter {
  public async coordinator(id: number): Promise<void> {
    return await new TransmedCoordinatorApi().delete(`${id}`);
  }
}

export default class TransmedCoordinatorService extends Service {
  public get read(): TransmedCoordinatorServiceReader {
    return new TransmedCoordinatorServiceReader();
  }
  public get create(): TransmedCoordinatorServiceCreator {
    return new TransmedCoordinatorServiceCreator();
  }
  public get update(): TransmedCoordinatorServiceUpdater {
    return new TransmedCoordinatorServiceUpdater();
  }
  public get delete(): TransmedCoordinatorServiceDeleter {
    return new TransmedCoordinatorServiceDeleter();
  }
}
